var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTextThumb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 4,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6436 14.6625C12.1095 14.6625 12.4873 14.2847 12.4873 13.8187V11.2875H20.9248V29.1187C20.9248 29.584 20.5463 29.9625 20.0811 29.9625H18.3936C17.9276 29.9625 17.5498 30.3403 17.5498 30.8062C17.5498 31.2722 17.9276 31.65 18.3936 31.65H28.5186C28.9845 31.65 29.3623 31.2722 29.3623 30.8062C29.3623 30.3403 28.9845 29.9625 28.5186 29.9625H26.8311C26.3658 29.9625 25.9873 29.584 25.9873 29.1187V11.2875H34.4248V13.8187C34.4248 14.2847 34.8026 14.6625 35.2686 14.6625C35.7345 14.6625 36.1123 14.2847 36.1123 13.8187V10.4438C36.1123 9.97778 35.7345 9.6 35.2686 9.6H11.6436C11.1776 9.6 10.7998 9.97778 10.7998 10.4438V13.8187C10.7998 14.2847 11.1776 14.6625 11.6436 14.6625Z",
    fill: "#A9AFAB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6436 38.4C12.1095 38.4 12.4873 38.0223 12.4873 37.5563V36.7125H34.4248V37.5563C34.4248 38.0223 34.8026 38.4 35.2686 38.4C35.7345 38.4 36.1123 38.0223 36.1123 37.5563V34.1813C36.1123 33.7153 35.7345 33.3375 35.2686 33.3375C34.8026 33.3375 34.4248 33.7153 34.4248 34.1813V35.025H12.4873V34.1813C12.4873 33.7153 12.1095 33.3375 11.6436 33.3375C11.1776 33.3375 10.7998 33.7153 10.7998 34.1813V37.5563C10.7998 38.0223 11.1776 38.4 11.6436 38.4Z",
    fill: "#A9AFAB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextThumb);
export default __webpack_public_path__ + "static/media/text-thumb.be04c0b32e2652123f7dc167298d555d.svg";
export { ForwardRef as ReactComponent };